module.exports = __webpack_public_path__ + "static/media/flow123.d7405eb5.jpg";